import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { RequestAddBankDto, RequestEditBankDto, RequestCancelBankDto, RequestRejectBankDto, RequestReviseBankDto, RequestBankGetHistoryDto, ResponseGetBankMultipleDto, ResponseBankSupportDto, ResponseBankAccountGetHistoryDto, RequestApprovalDto } from '../dto/multibank.dto';
import { ResponsePaging } from '../../nest-responses';

@Injectable()
export class MultiBankApi {

	private service: string = '';
	private model: string = 'multibank';

	constructor(
		public nestApiProvider: NestApiProvider,
	) {
	}

	public addBankRequest(payload: RequestAddBankDto): Observable<any> {
		const method: string = 'POST';
		const func: string = 'addBankRequest';
		const params: any = payload;
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
		return this.nestApiProvider.request(method, url, params, urlParams, body);
	}

	public approvalBankRequest(payload: RequestApprovalDto): Observable<any> {
		const method: string = 'POST';
		const func: string = 'approvalBankRequest';
		const params: any = payload;
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
		return this.nestApiProvider.request(method, url, params, urlParams, body);
	}

	public rejectBankRequest(payload: RequestRejectBankDto): Observable<any> {
		const method: string = 'PUT';
		const func: string = 'rejectBankRequest';
		const params: any = payload;
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
		return this.nestApiProvider.request(method, url, params, urlParams, body);
	}

	public reviseBankRequest(payload: RequestReviseBankDto): Observable<any> {
		const method: string = 'PUT';
		const func: string = 'reviseBankRequest';
		const params: any = payload;
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
		return this.nestApiProvider.request(method, url, params, urlParams, body);
	}

	public editBankRequest(payload: RequestEditBankDto): Observable<any> {
		const method: string = 'POST';
		const func: string = 'editBankRequest';
		const params: any = payload;
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
		return this.nestApiProvider.request(method, url, params, urlParams, body);
	}

	public cancelBankRequest(payload: RequestCancelBankDto): Observable<any> {
		const method: string = 'PUT';
		const func: string = 'cancelBankRequest';
		const params: any = payload;
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
		return this.nestApiProvider.request(method, url, params, urlParams, body);
	}

	public getBankMultiDetail(payload: { empId: string }): Observable<ResponseGetBankMultipleDto> {
		const method: string = 'GET';
		const func: string = 'getBankMultiDetail';
		const params: any = {};
		const urlParams: any = payload;
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
		return this.nestApiProvider.request<ResponseGetBankMultipleDto>(method, url, params, urlParams, body);
	}

	public getBankSupport(): Observable<ResponseBankSupportDto> {
		const method: string = 'GET';
		const service: string = 'payroll';
		const model: string = 'bankmgt';
		const func: string = 'getBankSupport';
		const params: any = {};
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, model, func, {}, urlParams, service);
		return this.nestApiProvider.request<ResponseBankSupportDto>(method, url, params, urlParams, body);
	}

	public getHistory(payload: RequestBankGetHistoryDto): Observable<ResponsePaging<ResponseBankAccountGetHistoryDto>> {
		const method: string = 'GET';
		const func: string = 'getHistory';
		const params: any = {};
		const urlParams: any = payload;
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
		return this.nestApiProvider.request<ResponsePaging<ResponseBankAccountGetHistoryDto>>(method, url, params, urlParams, body);
	}


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/multibank.api.ts